import { useState } from "react";
import deleteImage from "../../../Customize/Tabs/CustomizeTab/CustomizedField/Images/delete.svg";
import DeleteBtn from "../../../../../../../components/Buttons/DeleteBtn";
import DeletePopup from "../../../../../../../components/CommonPopups/DeletePopup";
import selectedValueAutomation from "../../../../../../../assets/images/selectedValueAutomation.svg";
import tabler from "../../../../../../../assets/images/tabler-icon-target.svg";

const SelectedFieldCard: any = ({
  label,
  value,
  onDelete,
  deleteAction,
  field,
  isBelowMissingHigh,
}: any) => {
  const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);

  const handleDeleteConfirmed = () => {
    setShowDeletePopup(false);
    onDelete(field);
  };

  const handleDeleteCancelled = () => {
    setShowDeletePopup(false);
  };

  return (
    <div
      style={{
        width: "100%",
        background: "#FFFFFF",
        border: "1px solid #E4E7EC",
        borderRadius: "8px",
        padding: "20px 16px 16px 16px",
        position: "relative",
        borderTopLeftRadius: "1px",
        borderTopRightRadius: "6px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "-25px",
            left: "-1px",
            background: "#FFFFFF",
            border: "1px solid #E4E7EC",
            borderBottom: "none",
            borderTopLeftRadius: "6px",
            borderTopRightRadius: "6px",
            padding: "2px 8px",
            fontSize: "13px",
            color: "#667085",
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <img src={tabler} />
          {label}
        </div>
        <div
          style={{
            position: "absolute",
            right: "10px",
          }}
        >
          {deleteAction && (
            <DeleteBtn
              icon={deleteImage}
              onClick={() => setShowDeletePopup(!showDeletePopup)}
            />
          )}
          {showDeletePopup && (
            <DeletePopup
              open={showDeletePopup}
              onClose={handleDeleteCancelled}
              noBtnClick={handleDeleteCancelled}
              yesBtnClick={handleDeleteConfirmed}
              title={"Are you sure you want to delete this question?"}
            />
          )}
        </div>
      </div>

      <div
        style={{
          border: isBelowMissingHigh ? "1px solid red" : "1px solid #11C89B",
          borderRadius: "8px",
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: isBelowMissingHigh ? "#edd7d5" : "#F9FFFD",
          marginTop: "15px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <img src={selectedValueAutomation} />
          <span
            style={{
              fontSize: "15px",
              fontWeight: 500,
              color: "#101828",
            }}
          >
            {value}
          </span>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="none"
          viewBox="0 0 24 24"
          stroke={isBelowMissingHigh ? "red" : "#11C89B"}
          strokeWidth="2"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </div>
    </div>
  );
};

export default SelectedFieldCard;
